import { createContext } from 'react'

import type AddParticipantController from '@src/app/voice/store/AddParticipantController'
import type CallTransferController from '@src/app/voice/store/CallTransferController'
import type { ActiveCall } from '@src/service/voice'

interface ICallContext {
  addParticipantController: AddParticipantController
  transferController: CallTransferController
  call: ActiveCall
  openConfirmationModal: boolean
  setOpenConfirmationModal: (value: boolean) => void
}

export const CallContext = createContext<ICallContext>({
  addParticipantController: {} as AddParticipantController,
  transferController: {} as CallTransferController,
  call: {} as ActiveCall,
  openConfirmationModal: false,
  setOpenConfirmationModal: () => null,
})
